module.exports = __webpack_public_path__ + "static/media/qualitas-vial.f5882d05.svg";